<style lang="scss" scoped>
.colorcontainer {
  width: 100%;
  height: 100%;
  .color {
    width: 100%;
    height: 100%;

    span {
      opacity: 0;
      width: 100%;
      display: block;
      text-align: center;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
      transition: all 200ms ease;
    }

    &.color-nothing {
      background-color: #fff;
    }

    &.color-low {
      background-color: $c-light-blue;
    }

    &.color-medium {
      background-color: $c-medium-blue;
    }

    &.color-high {
      background-color: $c-dark-blue;
    }
  }
}
</style>

<template>
  <div class="colorcontainer">
    <div class="color" :class="`color-${clazz}`"></div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { useStore } from 'vuex';

export default defineComponent({
  props: {
    value: { type: Number, required: true },
  },
  setup(props) {
    const store = useStore();
    const clazz = computed(() => store.getters.getRating(props.value));
    return { clazz };
  },
});
</script>
